<div class="p-2">
    <adaa-data-table
        #adaaDataTable
        [apiName]="'getHelpPaths'"
        [titleHeader]="'help.help_modal.title' | translate"
        [configKey]="Constants.MAIN_TABLE_LIST_CONF_KEY.HELP_MODAL_LIST"
        [enableViewAction]="false"
        (actionClicked)="getAction($event)"
        (addNewClicked)="addNew()"
    ></adaa-data-table>
</div>
